import { render, staticRenderFns } from "./ExamFreedomRule.vue?vue&type=template&id=7af45324&scoped=true&"
import script from "./ExamFreedomRule.vue?vue&type=script&lang=js&"
export * from "./ExamFreedomRule.vue?vue&type=script&lang=js&"
import style0 from "./ExamFreedomRule.vue?vue&type=style&index=0&id=7af45324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af45324",
  null
  
)

export default component.exports